<template>
  <article class="exam-container" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
           infinite-scroll-immediate="false" infinite-scroll-distance="10">
    <RouterNav name="创建考试"/>
    <div v-if="!noticeHidden || superAdmin !== '2'">
      <Explain :superAdmin="superAdmin" @noticeChange="noticeChange"></Explain>
    </div>
    <div v-else>
      <div class="nav-tabs">
        <Tab :list="moduleList" :index="moduleIndex" :type="2" @tabChange="moduleChange"></Tab>
        <Tab :list="subModuleList" :index="subModuleIndex" :type="3" @tabChange="subModuleChange"></Tab>
      </div>
      <section class="content">
        <transition-group name="list-complete" tag="div">
          <div class="list" v-for="(item, index) in list" :key="item.id">
            <div class="list-content">
              <div class="left">
                <div>{{ item.shortName || item.name }}</div>
              </div>
              <div class="right">
                <div class="btn" @click="check(index)" v-if="item.topicType === '1'">查看</div>
                <div :class="['btn', 'add-btn', item.selected ? 'selected-btn' : '']"
                     @click="addWork(index)">{{ item.selected ? '已添加' : '添加' }}
                </div>
              </div>
            </div>
          </div>
        </transition-group>
        <div class="disabled" v-if="disabled">没有更多了...</div>
      </section>
      <examTrolley @listState="listState" />
    </div>
  </article>
</template>

<script>
import RouterNav from "@/components/RouterNav";
import Tab from '@/components/tab.vue'
import Explain from './components/Explain.vue'
import examTrolley from '@/components/examTrolley.vue'

export default {
  name: 'assignExam',
  components: {
    RouterNav,
    Tab,
    Explain,
    examTrolley
  },
  data() {
    return {
      subModuleList: [{id: 0, name: '通用试题'}, {id: 1, name: '专用试题'}],
      moduleList: [],
      moduleList1: [{id: 1, name: '七年级'}, {id: 2, name: '八年级'}, {id: 3, name: '九年级'}],
      moduleList2: [{id: 4, name: '高一'}, {id: 5, name: '高二'}, {id: 6, name: '高三'}],
      moduleIndex: 0,
      subModuleIndex: 0,
      list: [],
      pageIndex: 1,
      pageSize: 20,
      disabled: false,
      noticeHidden: false,
      superAdmin: '0'
    }
  },
  created() {
    const gradeTypeId = sessionStorage.getItem('gradeTypeId')
    this.moduleList = gradeTypeId === '7' ? this.moduleList1 : this.moduleList2
    this.superAdmin = sessionStorage.getItem('superAdmin')
    this.noticeHidden = localStorage.getItem('noticeHidden')
    this.getList()
  },
  methods: {
    noticeChange(hidden) {
      if (hidden) {
        localStorage.setItem('noticeHidden', 1)
      }
      this.noticeHidden = true
    },
    load() {
      this.pageIndex += 1
      this.getList()
    },
    listState() {
      const {examWorkList} = this.$store.state
      const {list} = this
      for (let i = 0, len = list.length; i < len; i += 1) {
        list[i].selected = false
        if (examWorkList[list[i].id]) {
          list[i].selected = true
          this.$set(this.list, i, list[i])
        }
      }
      this.$forceUpdate()
    },
    check(index) {
      const {list} = this
      const {id} = list[index]
      const {name} = list[index]
      this.$router.push({
        name: 'paperDetail',
        query: {
          id,
          name,
          type: 'exam'
        }
      })
    },
    addWork(index) {
      const {list} = this
      const {id} = list[index]
      const {selected} = list[index]
      const {type} = list[index]
      if (!selected) {
        const {examWorkList} = this.$store.state
        if (Object.keys(examWorkList).length > 0 && type !== examWorkList[Object.keys(examWorkList)[0]].type) {
          this.$alert('请布置相同类型的试题', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        const name = list[index].shortName || list[index].name
        const obj = {
          id,
          name,
          type,
          exam: true
        }
        this.$store.commit('listAdd', obj)
      } else {
        const obj = {
          id,
          exam: true
        }
        this.$store.commit('listDel', obj)
      }
      list[index].selected = !list[index].selected
      this.$forceUpdate()
    },
    moduleChange(index) {
      this.moduleIndex = index
      this.pageIndex = 1
      this.getList()
    },
    subModuleChange(index) {
      this.subModuleIndex = index
      this.pageIndex = 1
      this.getList()
    },
    getList() {
      const {moduleList} = this
      const {subModuleList} = this
      const {moduleIndex} = this
      const {subModuleIndex} = this
      const {id: gradeTypeId} = moduleList[moduleIndex]
      const {id: selectType} = subModuleList[subModuleIndex]
      const {pageIndex} = this
      const {pageSize} = this
      this.loading = true
      this.$axios({
        method: 'post',
        url: this.$urls.getExamList,
        data: {
          gradeTypeId,
          selectType,
          pageIndex,
          pageSize
        }
      }).then((response) => {
        this.loading = false
        if (response.state === '11') {
          const {data} = response
          this.disabled = data.length < pageSize
          for (let i = 0, len = data.length; i < len; i += 1) {
            data[i].selectType = selectType
          }
          this.list = pageIndex === 1 ? data : [...this.list, ...data]
          this.listState()
        } else {
          if (pageIndex > 1) this.pageIndex -= 1
        }
      }).catch(() => {
        if (pageIndex > 1) this.pageIndex -= 1
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.exam-container {
  overflow: auto;
  height: calc(100vh - 80px);
}

.title {
  height: 84px;
  line-height: 84px;
  padding-left: 28px;
  font-size: 20px;
}

.nav-tabs {
  background-color: #fff;
  padding-bottom: 13px;
}

.content {
  background-color: #fff;
  /*height: calc(100vh - 289px);*/
  overflow: auto;
  padding: 10px 28px;
  margin-top: 10px;

  .list {
    padding: 0 28px;
    border-radius: 8px;
    transition: transform .5s;

    &:hover {
      background-color: #F6F6F6;
    }

    .list-content {
      @include flex(space-between);
      height: 88px;
      border-bottom: 1px solid #F1F1F1;
      @include font;

      .num {
        @include font(14px, #999);
        margin-top: 10px;
      }

      .right {
        @include flex;

        .num {
          @include font(14px, #309AF2);
          margin-right: 14px;
        }

        .btn {
          width: 67px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #E5E5E5;
          border-radius: 15px;
          @include font(13px, #999999, center);
          cursor: pointer;

          &:hover {
            color: #333333;
          }
        }

        .add-btn {
          color: #309AF2;
          border-color: #309AF2;
          margin-left: 28px;

          &:hover {
            background-color: #309AF2;
            color: #fff;
          }
        }

        .selected-btn {
          border-color: transparent;
        }
      }
    }
  }
}

.disabled {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #999;
  text-align: center;
}
</style>
